<template>
    <div class="main-products-data-container" :class="{ 'has-return-ribbon': hasOnReturn }">

        <div class="product-price-container">
            <!-- Дроповая цена (правая часть блока) -->
            <div class="drop-price text-left" v-if="is_drop && isDropProduct">
                <div class="drop-price-text">Цена дроп</div>
                <div class="price" >{{ dropPrice }} ₽</div>
            </div>

            <!-- Розничная цена (левая часть блока) -->
            <div :class="{ 'retail-price': true, 'text-right': is_drop && isDropProduct}">
                <div class="retail-price-text">Цена розница</div>
                <div class="price">{{ retailPrice }} ₽</div>
            </div>
        </div>

        <!-- Кнопка-ссылка на пак фотографий (В СТИЛЕ КОМПОНЕНТА) -->
        <a :href="photoPackUrl" target="_blank" class="photo-pack-link" v-if="is_drop && photoPackUrl">
            <div class="photo-pack-button">
                <span class="photo-pack-icon">📸</span>
                <span class="photo-pack-text">Фото товара</span>
                <span class="photo-pack-arrow">→</span>
            </div>
        </a>

        <!-- Открывающиеся блоки -->
        <div class="product-data-lists" v-if="!isFromAbroad">

            <!-- Наличие (размер/количество) -->
            <div class="opens-data-list">
                <div class="opens-data-list-main-container" :class="{ opened: isOpened }">
                    <!-- Заголовок блока -->
                    <div class="opens-data-list-header">В наличии</div>

                    <!-- Контейнер для контента (фото, размеры и т.д.) -->
                    <div class="opens-data-list-content" :class="{ visible: isOpened }">
                        <!-- Размеры и их количество -->
                        <div class="product-size-quantyty">
                            <template v-for="([size, quantity], index) in Object.entries(productPresence)" :key="index">
                                <div class="availability-size">{{ size }}</div>
                                <div class="availability-quantity">{{ quantity }}шт.</div>
                            </template>
                        </div>

                    </div>
                </div>

                <!-- Стрелка в кружке (для открытия блока) -->
                <div class="circle-arrow" @click="toggleOpen">
                        <!-- Инлайновый SVG -->
                        <svg
                            class="arrow-icon"
                            :class="{ upside: isOpened }"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="2" />
                            <path
                            d="M13.5 8L9.5 12L13.5 16"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            />
                        </svg>
                </div>
            </div>

            <!-- Таблица размеров -->
        </div>

        <!-- На возврате (едет к нам обратно) -->
        <div class="product-data-lists" v-if="hasOnReturn">
            <div class="opens-data-list on-return-list">
                <div class="opens-data-list-main-container on-return-container">
                    <div class="opens-data-list-header on-return-header">На возврате</div>

                    <div class="opens-data-list-content" :class="{ visible: isReturnOpened }">
                        <div class="product-size-quantyty">
                            <template v-for="([size, quantity], index) in onReturnEntries" :key="'return-' + index">
                                <div class="availability-size">{{ size }}</div>
                                <div class="availability-quantity">{{ quantity }}шт.</div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="circle-arrow on-return-arrow" @click="isReturnOpened = !isReturnOpened">
                    <svg
                        class="arrow-icon"
                        :class="{ upside: isReturnOpened }"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <circle cx="12" cy="12" r="11" stroke="currentColor" stroke-width="2" />
                        <path
                        d="M13.5 8L9.5 12L13.5 16"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
        isOpened: false,
        isReturnOpened: false,

        // Переменная для хранения данных о дроп пользователе   
        is_drop: false,
    };
  },
  props: {
    retailPrice: {
      type: Number,
      required: true
    },
    dropPrice: {
      type: Number,
      required: true
    },
    productPresence: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    onReturn: {
      type: Object,
      default: () => ({}),
    },
    isDropProduct: {
        type: Boolean,
        required: true,
    },
    photoPackUrl: {  // НОВЫЙ ПРОПС для ссылки на фото
        type: String,
        default: ''
    },
    isFromAbroad: {
        type: Boolean,
        default: false,
        required: true
    }
  },
  computed: {
    onReturnEntries() {
      return Object.entries(this.onReturn || {}).filter(([, quantity]) => quantity > 0);
    },
    hasOnReturn() {
      return !this.isFromAbroad && this.onReturnEntries.length > 0;
    }
  },
  methods: {
    // Открытие/закрытие блока с наличием
    toggleOpen() {
      this.isOpened = !this.isOpened;
    },

    // Проверка пользователя
    checkDropUser() {
        this.is_drop = localStorage.getItem('is_drop') === 'true';
        console.log('Проверка пользователя:', this.is_drop);
    }

  },

  mounted() {
    // Проверяем пользователя при монтировании компонента
    this.checkDropUser();
  },
}
</script>

<style>
.main-products-data-container {
    color: white;
    font-family: 'Inter', sans-serif;
    position: absolute;
    top: 150vw;
    width: 92%;
    padding: 4vw;
    margin: 0 4vw;
    background-color: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 20px;
}

.product-price-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

.drop-price {
    font-size: 16px;
    font-weight: 700;
}

.retail-price {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 4vw;
}

.price {
    font-size: 24px;
    font-weight: 700;
}

.opens-data-list {
    display: grid;
    grid-template-columns: 11fr 1fr;
    align-items: start;
    gap: 2vw;
}

.opens-data-list-main-container {
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-radius: 30px;

}

a {
    text-decoration: none;
    color: white;
}

.opens-data-list-header {
    font-size: 24px;
    height: 10vw;
    text-align: center;
}

.opens-data-list-content {
    display: none;
}

.product-size-quantyty {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    color: white;
    width: 60%;
    justify-content: center;
    align-items: end;
    padding: 4vw 0;
}

.availability-size {
    font-size: 24px;
}

.availability-quantity {
    text-align: right;
    font-size: 20px;
}

.circle-arrow {
    width: 10vw;
    height: 10vw;
}

.arrow-icon {
    color: rgba(255, 255, 255, 0.4);
    transform: rotate(-90deg);
}

.upside {
    transform: rotate(90deg);
}

.visible {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* КНОПКА В СТИЛЕ КОМПОНЕНТА */
.photo-pack-link {
    text-decoration: none;
    display: block;
    margin: 4vw 0;
}

.photo-pack-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2vw;
    padding: 3vw;
    border: 3px solid rgba(255, 255, 255, 0.4);
    border-radius: 30px;
    background: transparent;
    color: white;
    transition: all 0.3s ease;
}

.photo-pack-button:hover {
    border-color: rgba(255, 255, 255, 0.8);
    background: rgba(255, 255, 255, 0.05);
    transform: scale(1.02);
}

.photo-pack-button:active {
    transform: scale(0.98);
}

.photo-pack-icon {
    font-size: 5vw;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.photo-pack-text {
    font-size: 5vw;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.photo-pack-arrow {
    font-size: 5vw;
    transition: transform 0.3s ease;
}

.photo-pack-button:hover .photo-pack-arrow {
    transform: translateX(1vw);
}

/* Адаптивность для десктопа */
@media (min-width: 768px) {
    .photo-pack-icon {
        font-size: 24px;
    }
    
    .photo-pack-text {
        font-size: 18px;
    }
    
    .photo-pack-arrow {
        font-size: 20px;
    }
    
    .photo-pack-button {
        padding: 12px 24px;
        gap: 8px;
    }
}

.main-products-data-container.has-return-ribbon {
  top: 170vw;
}

.on-return-list {
  margin-top: 4vw;
}

.on-return-container {
  border-color: #F2912E;
}

.on-return-header {
  color: #F2912E;
}
</style>